import { useEffect, useState } from 'react'
import * as TE from 'fp-ts/es6/TaskEither'
import { pipe } from 'fp-ts/es6/function'
import { teGetErrorOutageData, DEFAULT_ERROR_OUTAGE, ErrorOutage } from './get_error_outage_data'

interface ErrorOutageHookState {
  data: ErrorOutage
  loading: boolean
}

export const useErrorOutage = (): ErrorOutageHookState => {
  const [state, setState] = useState<ErrorOutageHookState>({
    data: DEFAULT_ERROR_OUTAGE,
    loading: true,
  })

  const fetchErrorOutageData = (): void => {
    pipe(
      teGetErrorOutageData(),
      TE.map(response => setState({ data: response, loading: false })),
    )()
  }

  useEffect(() => fetchErrorOutageData(), [])

  return state
}
